<template>
  <div class="wrap Address">
    <div class="header">
      <NavBar
        title="Add New Address"
        left-arrow
        @click-left="$router.go('-1')"
        class="no_bg"
      >
        <!-- <span slot="right" icon="cart-o"><Icon name="cart-o"  badge="99+"/></span> -->
      </NavBar>
    </div>
    <div class="main">
      <Form validate-first @failed="onFailed" ref="form">
        <!-- <DropdownMenu>
              <DropdownItem title-class="AddressDroItem" v-model="form.value1" :options="option1" />
            </DropdownMenu> -->
        <Field
          @focus="slectAddress()"
          v-model="fieldValue"
          required
          is-link
          readonly
          placeholder="Please select the region"
          :rules="[{ required: true, message: 'Region is a required field.' }]"  
          @click="show = true"
        />
        <Field
          required
          v-model="form.street"
          clearable
          placeholder="Street "
          :rules="[{ required: true, message: 'Street address is a required field.' }]"  
        />
        <Field
          v-model="form.address"
          type="tel"
          clearable
          placeholder="Apt,Suite,Unit,Building(Optional)"
        />
        <!-- <Field v-model="text1"  placeholder="State & City" @focus="slectAddress()" :rules="[{ required: true, message: '请选择省市区' }]"  /> -->

        <Field
          required  
          v-model="form.zipCode"
          type="tel"
          clearable
          placeholder="ZIP Code"
          :rules="[
            {
              required: true,
              validator: FormHlep.IsZipCode,
              message: 'Please enter a 5-digit zip code ,such as 12345'
            }
          ]"
        />
        <Field
          required
          v-model="form.receiverName"
          clearable
          placeholder="Full Name(First and Last Name)"
          :rules="[{ required: true, message: 'Full name is a required field.' }]"
        />
        <Field
          required
          v-model="form.phone"
          type="digit" 
          clearable
          placeholder="Phone number"
          :rules="[
            {
              required: true,
              message: 'Phone number is a required field.'
            }
          ]"
        >
        <!-- <Field
          required
          v-model="form.phone"
          type="tel"
          clearable
          placeholder="Phone number"
          :rules="[
            {
              required: true,
              validator: FormHlep.IsPhone,
              message: 'Phone number is a required field.'
            }
          ]"
        > -->
          <template #left-icon>
            <div class="leftImg"><img src="../../../public/img/usa.png" alt=""> <span>+1</span></div>
          </template>
        </Field>

        <Field
          required
          :border="true"
          v-model.trim="form.receiverEmail"
          clearable
          placeholder="Email"
          :rules="[
            {
              required: true,
              validator: FormHlep.IsEmal,
              message: 'Email is a required field.'
            }
          ]"
        >
          <template #left-icon>
            <div class="leftImg"><img src="../../../public/img/email.png" alt=""></div>
          </template>
        </Field>
        <div class="pd10">
          <Button
            color="#16C7CE"
            type="primary"
            round
            block
            native-type="submit"
            @click="Submit"
            >Apply</Button
          >
        </div>
      </Form>
    </div>
    <!-- :columns-placeholder="['请选择', '请选择', '请选择']"    添加请选择 -->

    <Popup v-model="show" round position="bottom">
      <Cascader
        v-model="cascaderValue"
        placeholder="Please select" 
        title="State & City is a required field."
        :options="options"
        @close="show = false"
        @finish="onFinish"
        @change="onChange"
      />
    </Popup>

    <!-- <Popup v-model="show1" position="bottom">
        <Area v-show="show1"  title="标题" value="120101" :area-list="areaList"  @change="aa($event)" 
        @confirm="changeAddress" @cancel="show1=false"/>
      </Popup> -->
  </div>
</template>
<script>
import FormHlep from "@/utils/formHlep"; //正则
import request from "../../api/request";
import { getStore, setStore } from "../../utils/storage";
export default {
  data() {
    return {
      FormHlep,
      isLogin: getStore("user"), //登陆才有
      form: {
        street: "", //街道
        address: "", //具体地址门牌号
        zipCode: "", //  邮政编码
        receiverName: "", //收货人名字
        phone: "", //手机号
        receiverEmail: "" //收货人邮箱
      },
      option1: [{ text: "United States", value: 0 }],
      show: false,
      fieldValue: "", //选择省市区绑定的地址
      cascaderValue: "", //选择省市区绑定的地址ID
      // 选项列表，children 代表子选项，支持多级嵌套
      options: []

      // editAddress:JSON.parse(getStore('address')) || false,  // 地址列表页缓存的地址
    };
  },
  created() {
    this.getAreaList(); //获取国
    if (this.$route.query.customerAddrId) {
      //编辑需要赋值
      request(
        "get",
        `cms/customeraddr/info/${this.$route.query.customerAddrId}`
      ).then(res => {
        if (res.code === 200) {
          let data = res.data;
          this.form.street = data.street;
          this.form.address = data.address;
          this.form.zipCode = data.zipCode;
          this.form.receiverName = data.receiverName;
          this.form.phone = data.phone;
          this.form.receiverEmail = data.receiverEmail;
          this.fieldValue =
            data.countriesEntity.name +
            "/" +
            data.statesEntity.name +
            "/" +
            data.citiesEntity.name;
          this.cascaderValue =
            data.country + "/" + data.states + "/" + data.city;
        }
      });
    }
  },
  methods: {
    // 全部选项选择完毕后，会触发 finish 事件
    onFinish({ selectedOptions }) {
      this.show = false;
      this.fieldValue = selectedOptions.map(option => option.text).join("/"); //名字赋值
      this.cascaderValue = selectedOptions
        .map(option => option.value)
        .join("/"); // id赋值
      console.log(this.fieldValue, this.cascaderValue);
    },
    getAreaList() {
      request("post", `cms/countries/queryByIds?ids=226&ids=44`).then(res => {
        //获取国
        if (res.code === 200) {
          let list = res.data;
          list.forEach(item => {
            // this.areaList.province_list[item.id] = item.name
            if (item.id == "226") {
              //获取州
              // console.log(item)
              let item1 = {
                text: item.name,
                value: item.id,
                children: []
              };
              this.options.push(item1);
            }
          });
        }
      });
    },
    // 改变省市区
    onChange({ value }) {
      // console.log(value)
      // console.log(this.options)
      if (value === this.options[0].value) {
        //如果是多个要循环一次，这里只有一个美国直接去下标0
        request("get", "cms/states/getByCountryId", { countryId: value }).then(
          res => {
            let list = res.data;
            list.forEach((item, index) => {
              let obj = {
                text: item.name,
                value: item.id,
                children: []
              };
              this.options[0].children.push(obj);
            });
          }
        );
      } else {
        this.options[0].children.forEach(i => {
          //判断点击的是不是2及的value
          if (i.value == value) {
            request("get", "cms/cities/getByStateId", {
              stateId: i.value
            }).then(res => {
              let list2 = res.data;
              list2.forEach(item => {
                let obj2 = {
                  text: item.name,
                  value: item.id
                };
                i.children.push(obj2);
              });
              // console.log(this.options)
            });
          }
        });
      }
    },

    slectAddress() {
      this.show = true;
      document.activeElement.blur(); //禁止弹起手机键盘挡住其它的
    },
    // 校验函数返回 true 表示校验通过，false 表示不通过
    validator(val) {
      return /1\d{10}/.test(val);
    },
    onFailed(errorInfo) {
      console.log("failed", errorInfo);
    },
    // 表单通过提交
    Submit() {
      // 全局表单验证
      this.$refs.form
        .validate()
        .then(() => {
          // this.$toast.success("提交成功");
          let data = {
            street: this.form.street, //街道
            address: this.form.address, //具体地址门牌号
            zipCode: this.form.zipCode, //  邮政编码
            receiverName: this.form.receiverName, //收货人名字
            phone: this.form.phone, //手机号
            receiverEmail: this.form.receiverEmail, //收货人邮箱
            isDefault: 0 //是否设置成默认地址(0：默认；1：非默认)
          };
          let streetArr = this.cascaderValue.split("/");
          data.country = streetArr[0]; //国家地区
          data.states = streetArr[1]; //州
          data.city = streetArr[2]; //市
          console.log(data);
          if (this.isLogin) {
            let url;
            let met;
            if (this.$route.query.customerAddrId) {
              url = "cms/customeraddr/update"; //编辑
              met = "put";
              data.customerAddrId = this.$route.query.customerAddrId;
            } else {
              url = "cms/customeraddr/save"; //新增
              met = "post";
            }
            request(met, url, data).then(res => {
              if (res.code === 200) {
                this.$toast.success("Added successfully");
                this.$router.push("/address");
                // this.$router.push({path:'/productItem',query: {id:i.productId}})
              }
            });
          } else {
            // 没登陆要缓存地址
            let dzARR = this.fieldValue.split("/"); //地址名称数组
            let parmas = {
              country: data.country, //国家
              countriesEntity: { name: dzARR[0] },
              states: data.states, //州
              statesEntity: { name: dzARR[1] },
              city: data.city, //市
              citiesEntity: { name: dzARR[2] },
              address: data.address, //具体地址门牌号
              street: data.street, //街道
              zipCode: data.zipCode, //  邮政编码
              receiverName: data.receiverName, //收货人名字
              phone: data.phone, //手机号
              receiverEmail: data.receiverEmail //收货人邮箱
            };
            console.log(parmas);
            setStore("Address", parmas); //  存储列表点击地址信息
            this.$toast.success("Added successfully");
            this.$router.go(-1);
          }
        })
        .catch(() => {
          // console.log(this.form);
          // this.$toast.fail("提交失败");
        });
    }
  }
};
</script>
<style lang="less" scoped>
.Address {
  .pd10 {
    padding: 10px;
  }
  .leftImg{
    display: flex;
    align-items: center;
    img{width: 26px;height: 26px}
    span{padding: 0 5px;}
  }
}
</style>
<style>
.AddressDroItem {
  padding-left: 0;
  text-align: left;
  width: 90%;
}
.Address .van-field__label {
  width: 30px;
}
</style>
